<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
            <div class="card-header card-header-flex">
                <div class="d-flex flex-column justify-content-center mr-auto">
                  <h5 class="mb-0 text-primary h3 font-weight-bold">{{ partnerName }}</h5>
                </div>
                <div class="d-flex flex-column justify-content-center">
                    <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มข้อมูลพนักงาน</a>
                </div>
                <div class="d-flex flex-column justify-content-center ">
                <a class="btn btn-primary" href="javascript: void(0);" @click="clearReload()"><i
                    class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
              </div>
            </div>
            <div class="card-body">
                <tableEmpPartnerSBO :dataSource="data" @edit-submitted="getFormEditEmpPartnerSBO" @edit-menu-submitted="getFormEditMenuEmpPartnerSBO"
                 @clear-reload="clearReload" @block-submitted="blockEmpPartnerSBO" :isReload="isReload"/>
            </div>
        </div>
        <a-modal v-model="visible" :title="formTitle" footer="">
            <formEmpPartnerSBO @close-form="closeModal" @return-form="submitForm" v-bind="sentDataForm"/>
        </a-modal>
    </div>
  </template>

<script>
import tableEmpPartnerSBO from './tableEmpPartnerSBO'
import formEmpPartnerSBO from './formEmpPartnerSBO'
import apiClient from '@/services/api'
import useNoti from '@/services/plugin/notification'
export default {
  components: {
    tableEmpPartnerSBO,
    formEmpPartnerSBO,
  },
  data() {
    return {
      formTitle: '',
      visible: false,
      visibleMenu: false,
      isloading: false,
      isReload: false,
      formEmpPartnerSboError: false,
      reloadTable: false,
      varidateCheck: [],
      menues: [],
      formLayout: 'horizontal',
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      data: [],
      roleAdmin: [],
      partnerName: '',
      form: {
        id: '',
        username: '',
        password: '',
        ban: '',
        email: '',
        firstname: '',
        lastname: '',
        phoneNumber: '',
        superPartner: '',
      },
      rules: {
        username: [
          { required: true, message: 'กรอก ยูสเซอร์เนม', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'กรอก รหัสผ่าน', trigger: 'blur' },
        ],
        reCheckPassword: [
          { required: true, message: 'กรอก ยืนยันรหัสผ่าน', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {

    sentDataForm: function () {
      return {
        form: this.form,
        menues: this.menues,
        isloading: this.isloading,
        rules: this.rules,
        roleAdmin: this.roleAdmin,
        formLayout: this.formLayout,
        labelCol: this.labelCol,
        wrapperCol: this.wrapperCol,
        error: this.formEmpPartnerSboError,
        validate: this.varidateCheck,
      }
    },
  },
  methods: {
    async getDataEmpPartnerSBO() {
      this.isReload = !this.isReload

      await apiClient.get(`/partner/getData/${this.$route.params.id}/all`).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.isReload = !this.isReload
          this.data = res.responseData.data
          this.partnerName = (res.responseData.data[0].name).toUpperCase()
        }
      }).catch(err => {
        useNoti('error', 'Error', err.message)
      })
    },
    showModal(event) {
      var title = (event === 'insert') ? 'เพิ่มข้อมูลพนักงานพาร์ทเนอร์' : (event === 'edit') ? 'แก้ไขข้อมูลพนักงานพาร์ทเนอร์' : ''

      if (event === 'insert') {
        this.form = {
          id: '',
          username: '',
          password: '',
          ban: '',
          email: '',
          firstname: '',
          lastname: '',
          phoneNumber: '',
          superPartner: 1,
        }
      }
      this.formTitle = title
      this.visible = true
    },
    showModalMenu() {
      var title = 'แก้ไขเมนูพนักงาน'

      if (event === 'insert') {
        this.form = {
          id: '',
          username: '',
          password: '',
          ban: '',
          email: '',
          firstname: '',
          lastname: '',
          phoneNumber: '',
          superPartner: 1,
        }
      }
      this.formTitle = title
      this.visibleMenu = true
    },
    handleCancel(e) {
      this.visible = false
    },
    async getEmpPartnerSBO(id) {
      this.reloadTable = !this.reloadTable
      await apiClient.get(`/partner/getData/${this.$route.params.id}/${id}`, {}).then(response => {
        const res = response.data
        if (res.code === '000') {
          const DataEmpPartner = res.responseData.data[0]
          const DatamenuesSelected = res.responseData.menuesSelected
          this.form = {
            id: DataEmpPartner.id,
            username: DataEmpPartner.username,
            password: DataEmpPartner.password,
            ban: DataEmpPartner.ban,
            email: DataEmpPartner.email,
            firstname: DataEmpPartner.firstname,
            lastname: DataEmpPartner.lastname,
            phoneNumber: DataEmpPartner.phoneNumber,
            superPartner: DataEmpPartner.superPartner,
            menuesSelected: DatamenuesSelected,
          }
        }
        this.reloadTable = !this.reloadTable
      }).catch(err => {
        this.notification('error', 'Error', err.message)
      })
    },
    async getFormEditEmpPartnerSBO(id) {
      await this.getEmpPartnerSBO(id)
      this.showModal('edit')
    },
    async getFormEditMenuEmpPartnerSBO(id) {
      await this.getEmpPartnerSBO(id)
      this.showModalMenu()
    },
    closeModal() {
      this.visible = false
    },
    notification(type, title, message) {
      this.$notification[type]({
        message: title,
        description: message,
      })
    },
    async submitForm(data) {
      this.isloading = !this.isloading

      const type = (this.formTitle === 'เพิ่มข้อมูลพนักงานพาร์ทเนอร์') ? 'POST' : (this.formTitle === 'แก้ไขข้อมูลพนักงานพาร์ทเนอร์') ? 'PUT' : ''
      const sentData = {
        partnerSboId: this.$route.params.id,
        username: data.form.username,
        password: data.form.password === undefined ? '' : data.form.password,
        reCheckPassword: data.form.reCheckPassword === undefined ? '' : data.form.reCheckPassword,
        email: data.form.email,
        firstname: data.form.firstname,
        lastname: data.form.lastname,
        phoneNumber: data.form.phoneNumber,
        superPartner: data.form.superPartner,
      }

      if (type === 'POST') {
        await apiClient.post('/partner', sentData).then(response => {
          this.isloading = !this.isloading
          // this.loading = false
          if (response.data.code === '000') {
            this.clearReload()
            this.notification('success', 'Success', response.data.message)
            this.visible = false
          } else {
            this.setErrorForm(response.data.responseData, response.data.message)
            this.notification('error', 'Error', response.data.message)
          }
        }).catch(err => {
          this.notification('error', 'Error', err.message)
        })
      } else if (type === 'PUT') {
        await apiClient.put(`/partner/${data.form.id}`, sentData).then(response => {
          this.isloading = !this.isloading
          if (response.data.code === '000') {
            this.clearReload()
            this.notification('success', 'Success', response.data.message)
            this.visible = false
          } else {
            this.setErrorForm(response.data.responseData, response.data.message)
            this.notification('error', 'Error', response.data.message)
          }
        }).catch(err => {
          this.notification('error', 'Error', err.message)
        })
      }
    },
    setErrorForm(responseData, message) {
      if (responseData.varidateCheck) {
        this.formEmpPartnerSboError = !this.formEmpPartnerSboError
        this.varidateCheck.message = message
        this.varidateCheck.validate = responseData.varidateCheck
      }
    },
    async blockEmpPartnerSBO(result) {
      const sentData = {
        ban: !result.ban,
      }

      await apiClient.put(`/partner/updateStatus/${result.id}`, sentData).then(response => {
        if (response.data.code === '000') {
          this.clearReload()
          this.notification('success', 'Success', response.data.message)
          this.visible = false
        } else {
          this.setErrorForm(response.data.responseData, response.data.message)
          this.notification('error', 'Error', response.data.message)
        }
      }).catch(err => {
        this.notification('error', 'Error', err.message)
      })
    },
    clearReload() {
      this.getDataEmpPartnerSBO()
    },
  },
  created() {
    this.getDataEmpPartnerSBO()
  },

}
</script>

  <style>
  .d-flex.flex-column.justify-content-center {
  padding: 3px;
  border-radius: 10%;
  }
  </style>
